import { render, staticRenderFns } from "./game-toggle.vue?vue&type=template&id=e1da3ae6&scoped=true&lang=pug&"
import script from "./game-toggle.vue?vue&type=script&lang=js&"
export * from "./game-toggle.vue?vue&type=script&lang=js&"
import style0 from "./game-toggle.vue?vue&type=style&index=0&id=e1da3ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1da3ae6",
  null
  
)

export default component.exports